import ApiService from "@/core/services/api.service";
import {PURGE_AUTH} from "./auth.module";
import JwtService from "@/core/services/jwt.service";
import {SET_PAGINATE} from "./paginate.module";

// action types
export const GET_CLIENTS = "getClients";
export const GET_CLIENT = "getClient";
export const UPDATE_CLIENT = "updateClient";
export const DELETE_CLIENT = "deleteClient";

// mutation types
export const SET_CLIENTS_ERROR = "setClientErrors";
export const SET_CLIENTS = "setClients";
export const SET_CLIENT = "setClient";
export const SET_CLIENT_LOAD = "setClientLoad";

const state = {
    errors: {},
    clients: {},
    load: true,
    client: {
        orders: []
    },
};

const getters = {
    gettersClients(state) {
        return state.clients;
    },
    paginateClients() {
        return state.paginate;
    },
    gettersClient(state) {
        return state.client;
    },
    errorsClient(){
        return state.errors;
    },
    getClientLoad(){
        return state.load;
    }
};

const actions = {

    [GET_CLIENTS](context, data) {
        return new Promise((resolve, reject) => {
            context.commit(SET_CLIENT_LOAD, true);
            ApiService.post("/clients", data)
                .then(({ data }) => {
                    resolve(data);
                    context.commit(SET_CLIENTS, data);
                    context.commit(SET_PAGINATE, data);
                    context.commit(SET_CLIENT_LOAD, false);
                })
                .catch(({ response }) => {
                    reject(response);
                    context.commit(SET_CLIENTS_ERROR, response.data.errors);
                    context.commit(SET_CLIENT_LOAD, false);
                });
        });
    },

    [GET_CLIENT](context, id) {
        context.commit(SET_CLIENT_LOAD, true);
        ApiService.get("/client", id)
            .then(({ data }) => {
                context.commit(SET_CLIENT, data);
                context.commit(SET_CLIENT_LOAD, false);
            })
            .catch(({ response }) => {
                context.commit(SET_CLIENTS_ERROR, response.data.errors);
                context.commit(SET_CLIENT_LOAD, false);
            });
    },

    [UPDATE_CLIENT](context, data) {
        if (JwtService.getToken()) {
            context.commit(SET_CLIENTS_ERROR, {});
            return new Promise((resolve, reject) => {
                ApiService.update("/client/update", data.id, data.client)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CLIENTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                        if (response.status === 422){
                            context.commit(SET_CLIENTS_ERROR, response.data.errors);
                        }
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }

    },

    [DELETE_CLIENT](context, id) {
        if (JwtService.getToken()) {
            return new Promise((resolve, reject) => {
                ApiService.delete("/client/soft-delete", id)
                    .then(({ data }) => {
                        resolve(data);
                        context.commit(SET_CLIENTS_ERROR, {});
                    })
                    .catch(({ response }) => {
                        reject(response);
                    });
            });
        } else {
            context.commit(PURGE_AUTH);
        }
    },
};

const mutations = {
    [SET_CLIENTS_ERROR](state, error) {
        state.errors = error;
    },

    [SET_CLIENTS](state, data) {
        state.clients = data.data;
    },

    [SET_CLIENT](state, product) {
        state.client = product.client;
    },

    [SET_CLIENT_LOAD](state, load) {
        state.load = load;
    },
};

export default {
    state,
    actions,
    mutations,
    getters
};
